<template>
  <div class="pt-4">
    <v-row no-gutters align="center">
      <h4 class="checkout-h4 accent--text">
        {{ $t("finished.card.youPay") }}{{ paidValue | currency }}
      </h4>
      <v-spacer></v-spacer>
      <h3
        class="checkout-h3 mr-2"
        :class="
          status === 'S' || orderStatus === 'in_process' || isWaitingApproval
            ? 'atention--text'
            : 'success--text'
        "
      >
        {{
          isWaitingApproval
            ? "Aguardando aprovação"
            : status === "S" || orderStatus === "in_process"
            ? $t("finished.card.analysis")
            : $t("finished.card.approved")
        }}
      </h3>

      <svg
        class="alert-card__icon"
        v-if="status !== 'S' && orderStatus !== 'in_process'"
        style="width: 24px; height: 24px"
        viewBox="0 0 24 24"
      >
        <path
          fill="#00a65a"
          d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
        />
      </svg>

      <v-icon class="alert-card__icon" v-else color="atention"
        >mdi-alert-circle-outline</v-icon
      >
    </v-row>

    <span class="checkout-h4 grey--text">
      em
      {{
        finalDetails?.orderData?.parcelas
          ? finalDetails.orderData.parcelas
          : finalDetails.installments
      }}{{ $t("finished.card.inCard") }}
      {{ buyer.card_number.substr(buyer.card_number.length - 4) }}
    </span>
    <div dark v-if="status === 'S'" class="alert-card">
      <v-icon class="alert-card__icon" color="error"
        >mdi-alert-circle-outline</v-icon
      >
      <div style="color: white; margin: 0 16px">
        {{ $t("finished.card.purchaseReview") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "productsTotal",
      "partialPayment",
      "finalDetails",
      "buyer",
      "paymentOption",
    ]),

    paidValue() {
      if (this.partialPayment) return this.partialPayment;
      if (this.buyer?.installment_amount && this.paymentOption === "CC")
        return this.buyer.installment_amount.total;
      return this.productsTotal;
    },

    status() {
      if (
        this.finalDetails &&
        this.finalDetails.orderData &&
        this.finalDetails.orderData.real_order_status
      )
        return this.finalDetails.orderData.real_order_status;
      else return "";
    },

    orderStatus() {
      if (this.finalDetails) {
        return this.finalDetails.status;
      }

      return "paid";
    },

    isWaitingApproval() {
      return this.finalDetails?.orderStatus === "W";
    },
  },
};
</script>
